import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppState } from '@core/app-state/reducers';
import { authSelector } from '@core/services/auth/state/authentication.selectors';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { User } from '../../models/user.model';
import { UserStoreService } from '../../services/user-store.service';

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
  userRole: FormControl = new FormControl('', Validators.required);
  isCurrentUserWarden$: Observable<boolean>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: User,
    private store: Store<AppState>,
    private userService: UserStoreService,
    private dialogRef: MatDialogRef<UserEditComponent>) {
    this.isCurrentUserWarden$ = this.store.select(authSelector.isWarden);
  }

  ngOnInit(): void {
    this.userRole.setValue(this.data.isWarden ? 'Warden' : this.data.isAdmin ? 'Admin' : 'Reader');
  }

  editUserRole(): void {
    const euid = this.data.userData.userName;
    const currentRole = this.data.isWarden ? 'Warden' : this.data.isAdmin ? 'Admin' : 'Reader';

    if (this.userRole.value !== currentRole) {
      this.userService.removeUserRole(euid, currentRole);
      setTimeout(() => this.userService.addUserRole(euid, this.userRole.value), 500);
    }

    this.dialogRef.close();
  }
}
